/*
 * @Description: 前端启动项目代理url
 * @Autor: lwq
 * @Date: 2020-06-19 20:09:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-20 15:13:20
 */

// 前端开发 代理url
// module.exports = 'http://192.168.0.200:9998'
// module.exports = 'http://192.168.0.111:9999'
// module.exports = 'http://192.168.0.123:9998'
// module.exports = 'http://192.168.0.115:9998'
// module.exports = 'http://192.168.0.249:9998'
// module.exports = 'http://192.168.0.105:9998'
module.exports = "http://192.168.0.103:9998";
// module.exports = 'https://testessbaseweb.kaifa000.com'
// module.exports = 'https://testbaseserver.kaifa000.com'

// module.exports = 'https://longxinsoft.gnway.cc:9999'
// module.exports = 'https://testbaseserver.kaifa000.com'
// module.exports = 'https://testessbaseweb.kaifa000.com'

// module.exports = 'https://qdebug-base-frontend.kaifa000.com'
